import { BookingErrorCode } from '../constants/booking.constants';

export type CustomerBlacklistStatus =
  | { blacklisted: false }
  | { blacklisted: true; customerReason: string | null };

export function isCustomerBlacklistedError(message: string | null | undefined) {
  return (
    typeof message === 'string' &&
    message.includes(BookingErrorCode.CustomerBlacklisted)
  );
}
